import { utagOfferApplied } from './utagOfferApplied';
import { utagTargetedOffersLogin } from './utagTargetedOffersLogin';
import { utagTargetedOffersLoad } from './utagTargetedOffersLoad';
import { utagMyOffersFilter } from './utagMyOffersFilter';
import { utagFavoritesWatchlistClicked } from './utagFavoritesWatchlistClicked';
import { utagAffirmBanner } from './utagAffirmBanner';
import { utagFavoritesLimitReached } from './utagFavoritesLimitReached';
import { utagFavoritesSignInPanelDisplayed } from './utagFavoritesSignInPanelDisplayed';
import { utagFavoritesWatchlistCardClicked, getUserAction, getProductEvent } from './utagFavoritesWatchlistCardClicked';
import { utagBannerLoad } from './utagBannerLoad';
import { utagEvent } from './utagEvent';
import { utagItineraryPanel } from './utagItineraryPanel';
import { utagRatingTooltip } from './utagRatingTooltip';
import { utagRatingViewMore } from './utagRatingViewMore';
import { utagOfferPillClicked } from './utagOfferPillClicked';
import { utagPagination } from './utagPagination';
import { utagShowOfferPill } from './utagShowOfferPill';
import { utagSortClicked } from './utagSortClicked';
import { utagPortClicked } from './utagPortClicked';
import { utagGuestClicked } from './utagGuestClicked';
import { utagCompareCheckbox } from './utagCompareCheckbox';
import { utagGoToCompare } from './utagGoToCompare';
import { utagComparePageLoad } from './utagComparePageLoad';
import { utagCloseComparisonClicked } from './utagCloseComparisonClicked';
import { utagCompareRemoveCruise } from './utagCompareRemoveCruise';
import { utagExploreItineraryLinkClicked } from './utagExploreItineraryLinkClicked';
import { utagComparePageWatchlistAndSelectDateButton } from './utagComparePageWatchlistAndSelectDateButton';

export {
	utagAffirmBanner,
	utagOfferApplied,
	utagTargetedOffersLogin,
	utagTargetedOffersLoad,
	utagMyOffersFilter,
	utagFavoritesWatchlistClicked,
	utagFavoritesWatchlistCardClicked,
	utagFavoritesLimitReached,
	utagFavoritesSignInPanelDisplayed,
	getUserAction,
	getProductEvent,
	utagBannerLoad,
	utagEvent,
	utagItineraryPanel,
	utagRatingTooltip,
	utagRatingViewMore,
	utagOfferPillClicked,
	utagPagination,
	utagShowOfferPill,
	utagSortClicked,
	utagPortClicked,
	utagGuestClicked,
	utagCompareCheckbox,
	utagGoToCompare,
	utagComparePageLoad,
	utagCloseComparisonClicked,
	utagCompareRemoveCruise,
	utagExploreItineraryLinkClicked,
	utagComparePageWatchlistAndSelectDateButton
};
